module.exports = __webpack_public_path__ + "assets/img/ecg-weiji-icon.2d3c4543.png";